import cx from "classnames";
import React from "react";

import { BasicButton, Icon, IconSize } from "@gaming/xds-react-js";
import { Eye } from "@gaming/xds-react-js-icons";

import { useProgramColorPicker } from "../../helpers/useProgramColorPicker";
import { useString } from "../../localization/localizationHelpers";
import * as styles from "./ViewButton.module.css";

type ViewButtonProps = Readonly<{
  onClick: () => void;
}>;

export const ViewButton = ({ onClick }: ViewButtonProps) => {
  const viewDetails = useString("viewDetails");
  const colorStyle = useProgramColorPicker();

  return (
    <div className={colorStyle}>
      <BasicButton
        as={"button"}
        className={styles.viewButton}
        onClick={onClick}
        onKeyDown={e => e.key === "Enter" && onClick?.()}
        tabIndex={0}
        role="link"
        textDecorationUnderline={true}
      >
        <Icon aria-hidden={true} icon={Eye} className={colorStyle} iconSize={IconSize.Custom} />
        <p className={cx(styles.viewButtonText, colorStyle)}>{viewDetails}</p>
      </BasicButton>
    </div>
  );
};
